import { render, staticRenderFns } from "./ticketModalItemForm.vue?vue&type=template&id=212d3176&scoped=true&"
import script from "./ticketModalItemForm.vue?vue&type=script&lang=js&"
export * from "./ticketModalItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212d3176",
  null
  
)

export default component.exports